// https://www.materialui.co/colors
// Primary: 500
// Dark: 800
// Light: 200

export const colorList = {
	BLACK: {
		primary: '#000000',
		dark: '#444444',
		light: '#aaaaaa',
	},
	
	GREY: {
		primary: '#f5f5f5',
		dark: '#e6e6e6',
		light: '#f1f1f1',
	},
	
	BLUE: {
		primary: '#2196F3',
		dark: '#1565C0',
		light: '#90CAF9',
	},
	
	RED: {
		primary: '#f44336',
		dark: '#c62828',
		light: '#ef9a9a',
	},
	
	GREEN: {
		primary: '#4CAF50',
		dark: '#2E7D32',
		light: '#A5D6A7',
	},
	
	ORANGE: {
		primary: '#FF9800',
		dark: '#EF6C00',
		darker: '#EF6C00',
		light: '#FFCC80',
		subtle: '#fff1db',
	},
	
	YELLOW: {
		primary: '#FFEB3B',
		dark: '#F9A825',
		light: '#FFF59D',
	},
	
	PURPLE: {
		primary: '#9C27B0',
		dark: '#6A1B9A',
		light: '#CE93D8',
	},
	
	
	WHITE: {
		primary: '#ffffff',
		dark: '#f1f1f1',
		light: '#ffffff',
	},
	
	TITLE: {
		primary: '#212a44',
		dark: '#080A10',
		light: '#212a44',
	},
	
	SUBTITLE: {
		primary: '#8e9ab3',
		dark: '#798399',
		light: '#8e9ab3',
	},
	
	TEXT: {
		primary: '#2f3750',
		dark: '#131620',
		light: '#4B5880',
	},
	
	TEXT_HINT: {
		primary: '#8e9ab3',
		dark: '#8e9ab3',
		light: '#8e9ab3',
	},
	
	PAGE: {
		primary: '#fffcf7',
		dark: '#7b7978',
		light: '#fffcf7',
		transparent: 'rgba(246,243,241,0)'
	},
	
	PAGE_LIGHT: {
		primary: '#ffffff',
		dark: '#ffffff',
		light: '#ffffff',
	},
	
	DIVIDER: {
		primary: '#f1f2f3',
		dark: '#e0e0e0',
		light: '#f1f2f3',
	},
	
	PRIMARY: {
		primary: '#ff9800',
		transparent: 'rgba( 255, 152, 0, 0.8 )',
		dark: '#c66900',
		light: '#ffc166',
		lighter: '#fff4e5'
	},
	
	BADGE: {
		primary: '#f44336',
	},
	
	ICONS: {
		violet: '#EE82EE',
		pink: '#FFC0CB',
		grey: '#808080',
		brown: '#A52A2A',
		dark_coral: '#C8385A',
		dark_violet: '#5D4157',
		dark_pastel_green: '#7A9F7C',
		dark_pastel_blue: '#5A7D9A',
		dark_pastel_red: '#B84B4B',
		dark_pastel_yellow: '#F9D9A3',
		dark_pastel_pink: '#F9B7AC',
		dark_pastel_grey: '#8F8F8F',
		dark_pastel_brown: '#8D6E63',
		light_coral: '#F08B8C',
		light_pastel_green: '#A7D8C8',
		light_pastel_blue: '#A2C4C9',
		light_pastel_red: '#F1948A',
		light_pastel_yellow: '#F9E79F',
		light_pastel_pink: '#F9D0C4',
		light_pastel_grey: '#D8D8D8',
		light_pastel_brown: '#B2986B',
		black: '#000000',
		white: '#ffffff'
	}
}
